import OadpAttributeRefer from './oadp-attribute-refer';
export default OadpAttributeRefer;
